export default __webpack_public_path__ + "static/media/hurdles.28b596a7.jpg";